<div class="container-fluid company-wrapper mt-1" *ngIf="entryD">

  <!-- ================= HEADER ================= -->
  <div class="company-header-card">
    <div class="company-title">
      <i class="fas fa-building"></i>
      Company Setup
    </div>
  </div>

  <!-- ================= COMPANY DETAILS ================= -->
  <div class="company-section-card">

    <h5 class="section-title">
      <i class="fas fa-warehouse"></i>
      Company Details
    </h5>

    <div class="row g-3">

      <div class="col-md-6">
        <label for="companyName">Company Name</label>
        <input type="text" class="form-control" id="companyName" name="companyName" placeholder="Enter Company Name" [(ngModel)]="entryD.CompanyName" (change)="save()" />
      </div>

      <div class="col-md-6">
        <label for="noFactor">Number of Factories</label>
        <input type="number" class="form-control" id="noFactor" name="noFactor" placeholder="Enter No. of Factories" [(ngModel)]="entryD.Nooffact" (change)="save()" />
      </div>

    </div>

  </div>


  <!-- ================= PRODUCTS ================= -->
  <div class="company-section-card mt-4">

    <h5 class="section-title">
      <i class="fas fa-boxes"></i>
      Products Setup
    </h5>

    <div class="row g-3">

      <!-- ===== Product 1 ===== -->
      <div class="col-md-6">
        <label for="prodName">Product 1 Name</label>
        <input type="text" class="form-control" id="prodName" name="prodName" placeholder="Enter Product 1 Name" [(ngModel)]="entryD.Product1Name" (change)="save()" />
      </div>

      <div class="col-md-6">
        <label for="platform">Platform</label>
        <select class="form-select" [(ngModel)]="entryD.platformId1" id="platform" name="platform">
          <option [ngValue]="null" disabled selected>Select Platform</option>
          <option *ngFor="let plat of platformList" [ngValue]="plat.platformId">
            {{ plat.platformName }}
          </option>
        </select>
      </div>


      <!-- ===== Product 2 ===== -->
      <div class="col-md-6">
        <label for="prodName">Product 2 Name</label>
        <input type="text" class="form-control" id="prodName" name="prodName" placeholder="Enter Product 2 Name" [(ngModel)]="entryD.Product2Name" (change)="save()" />
      </div>

      <div class="col-md-6">
        <label for="platform">Platform</label>
        <select class="form-select" id="Platform" name="Platform" [(ngModel)]="entryD.platformId2">
          <option [ngValue]="null" disabled selected>Select Platform</option>
          <option *ngFor="let plat of platformList" [ngValue]="plat.platformId">
            {{ plat.platformName }}
          </option>
        </select>
      </div>
    </div>
  </div>
</div>